import useCitizenForm from "./useCitizenForm";
import { Returned } from "../../../components/correspondence-module/correspondence/returned";

function CitizenFormScreen() {
  const { correspondenceFilter } = useCitizenForm();

  return <Returned correspondence={correspondenceFilter} />;
}

export default CitizenFormScreen;
